import { Component} from '@angular/core';
 
@Component({
    selector: 'app-simuladordebeneficio',
    templateUrl: './simuladordebeneficio.component.html',
    styleUrls: ['./simuladordebeneficio.component.scss']
})


export class simuladordebeneficioComponent {}